/**
 * Shared continue-page resolver for payment return (must stay aligned with
 * inlic-common-payment-return/src/common/utils/continueJourneyPage.js).
 * Used when gateway lands on a journey URL (misfire) instead of shared payment pages.
 */

const PRODUCT_ID_TO_JOURNEY_PAGE = {
  22062: "term-plan",
  22063: "term-plan",
  22070: "retirement-plan",
  22074: "retirement-plan",
  80012: "combo-plan",
  22083: "combo-plan",
  22079: "combo-plan",
  22073: "cancer-plan",
  22060: "cancer-plan",
};

const JOURNEY_PAGE_ALIASES = {
  "term-insurance": "term-plan",
  "term-journey": "term-plan",
  "term-plan": "term-plan",
  "insurance-journey": "combo-plan",
  "tulip-plan": "combo-plan",
  "combo-plan": "combo-plan",
  "retirement-plan": "retirement-plan",
  "cancer-plan": "cancer-plan",
  "health-plan": "cancer-plan",
  "health-journey": "cancer-plan",
};

const DEFAULT_JOURNEY_PAGE = "term-plan";

/** Pages the backend hardcodes from journey-type detection (not stale master). */
const SERVER_DETECTED_JOURNEY_PAGES = new Set([
  "cancer-plan",
  "retirement-plan",
  "combo-plan",
]);

export const normalizeJourneyPage = (value) =>
  String(value || "")
    .trim()
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");

const aliasJourneyPage = (page) => {
  if (!page) return "";
  const lower = page.toLowerCase();
  if (JOURNEY_PAGE_ALIASES[lower]) {
    return JOURNEY_PAGE_ALIASES[lower];
  }
  for (const [alias, canonical] of Object.entries(JOURNEY_PAGE_ALIASES)) {
    if (lower.endsWith(`/${alias}`) || lower.endsWith(alias)) {
      return canonical;
    }
  }
  return page;
};

export const resolveContinueJourneyPage = (apiPage, productId) => {
  const id = String(productId || "").trim();
  const fromId = id && PRODUCT_ID_TO_JOURNEY_PAGE[id] ? PRODUCT_ID_TO_JOURNEY_PAGE[id] : "";
  const aliasedApi = aliasJourneyPage(normalizeJourneyPage(apiPage));

  if (aliasedApi && SERVER_DETECTED_JOURNEY_PAGES.has(aliasedApi)) {
    return aliasedApi;
  }
  if (fromId) {
    return fromId;
  }
  if (aliasedApi) {
    return aliasedApi;
  }
  return DEFAULT_JOURNEY_PAGE;
};
